module.exports = __webpack_public_path__ + "media/alert.ab15e96c.mp3";